const modalForm = document.querySelector(".js-popup-form");
const modalclose = document.querySelector(".js-closeForm");

if (modalForm) {
	modalclose.addEventListener("click", () => {
		modalForm.classList.add("hidden");
	});
}

